namespace TotalPoll {
    import Component = TotalCore.Common.Component;
    import ILocationService = angular.ILocationService;
    import RepositoryService = TotalPoll.RepositoryService;


    @Component('components.totalpoll', {
        templateUrl: 'insights-browser-component-template',
        bindings: {}
    })
    class InsightsBrowserComponent {
        public filters: any = {};
        public metrics: any = {};
        public polls: any = {};
        public processing = true;

        constructor(private RepositoryService: RepositoryService, private $location: ILocationService, private pollId: number) {
            let urlParams = $location.search();

            this.filters.poll = Number(urlParams['poll']) || pollId || null;
            this.filters.from = urlParams['from'] || null;
            this.filters.to = urlParams['to'] || null;
        }

        $onInit() {
            this.loadPolls();
            if (this.filters.poll) {
                this.loadMetrics();
            }
        }

        isProcessing() {
            return this.processing;
        }

        loadMetrics() {
            if (!this.filters.poll) {
                this.updateUrl();
                this.metrics = {};
                return false;
            }

            this.processing = true;
            this.RepositoryService
                .getMetrics(this.filters)
                .then((response) => {
                    this.processing = false;
                    this.metrics = response;
                    this.updateUrl();
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status || ''} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadMetrics();
                    }
                });
        }

        loadPolls() {
            this.processing = true;
            this.RepositoryService
                .getPolls()
                .then((response) => {
                    this.processing = false;
                    this.polls = response;
                })
                .catch((response) => {
                    if (confirm(`Something went wrong in the last operation (${response.status} ${response.statusText || 'Unknown error'}). Retry?`)) {
                        this.loadPolls();
                    }
                });
        }

        resetFilters() {
            this.filters.from = null;
            this.filters.to = null;
            this.loadMetrics();
        }

        updateUrl() {
            this.$location.search(angular.extend({}, this.$location.search(), this.filters));
        }

        canExport() {
            return this.polls.length > 0;
        }

        exportAs(format) {
            this.RepositoryService.getDownload(format, this.filters);
        }
    }
}
